import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SeoHead from '@/components/feature/SeoHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotGames from './components/HotGames';
import LatestNews from './components/LatestNews';
import Promotions from './components/Promotions';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <SeoHead
        title="九游娱乐 - 官方正版游戏娱乐平台 | 海量精品游戏 丰厚福利活动"
        description="九游娱乐是您值得信赖的综合游戏娱乐平台，汇聚海量精品游戏、丰厚福利活动与极致娱乐体验。立即加入九游娱乐，畅享多元游戏世界，专业客服全天候护航，安全稳定，乐趣无限。"
        keywords="九游娱乐,九游娱乐官网,九游娱乐平台,九游娱乐游戏,九游娱乐注册,九游娱乐登录,九游娱乐活动优惠"
        canonicalUrl="https://www.jiuyou.com/"
        schemaType="home"
      />
      <Navbar />
      <HeroSection />
      <CategoryNav />
      <HotGames />
      <LatestNews />
      <Promotions />
      <TestimonialsSection />
      <CTASection />
      <Footer />
      <ScrollToTop />
    </main>
  );
}